import "./RestartButton.scss";
import { useNavigate } from "react-router-dom";
import { ReactComponent as RestartButton } from "../../assets/icons/restart.svg";
import { useDealershipUserContext } from "../../contexts/dealershipUserContext";
import { useRecordingSessionContext } from "../../contexts/recordingSessionContext";
import { useDealershipContext } from "../../contexts/dealershipContext";

export default function RestartButtonContainer({ dealershipId }) {
  const { baseURL } = useDealershipContext();
  const { clearDealershipUserInfo } = useDealershipUserContext();
  const { recordingEnabled } = useRecordingSessionContext();
  const navigate = useNavigate();

  function onRestartButton() {
    console.log("Clicked on Restart");
    clearDealershipUserInfo();
    console.log(`${baseURL}?audio=${recordingEnabled}`, "Restart Clicked");
    navigate(`${baseURL}?audio=${recordingEnabled}`);
  }

  return (
    <div className="restart" onClick={onRestartButton}>
      <span className="restart__button">
        <RestartButton />
      </span>
      <p className="restart__text">Restart</p>
    </div>
  );
}
